module.exports = __webpack_public_path__ + "img/logo.7fc5880d.svg";